module.exports = __webpack_public_path__ + "media/images/ava-1d4ed1fc.png";